import { render, staticRenderFns } from "./IntegrationsUserSettings.vue?vue&type=template&id=3c444ee4&scoped=true&"
import script from "./IntegrationsUserSettings.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsUserSettings.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationsUserSettings.vue?vue&type=style&index=0&id=3c444ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c444ee4",
  null
  
)

export default component.exports